<template>
    <v-row justify="center">
        <v-col sm="12" class="mb-0 pb-0">
            <v-dialog
                v-model="dialog"
                persistent
                max-width="60vw"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="primary"
                        dark
                        block
                        v-bind="attrs"
                        v-on="on"
                        :class="classes"
                        :disabled="disabled"
                    >
                        Adaugare feedback
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">Feedback oferta / client</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="6">
                                    <v-textarea
                                        v-model="form.feedback"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('feedback')"
                                        :class="{ 'error--text': hasErrors('feedback') }"
                                        class="primary--text"
                                        name="feedback"
                                        label="Feedback"
                                        data-vv-as="Feedback"
                                        data-vv-name="feedback"
                                    />
                                    <v-btn v-for="(feedbackTemplate, tIndex) in Static.offerFeedbackTemplates" :key="tIndex" @click="form.feedback = feedbackTemplate" x-small class="ma-2">{{ feedbackTemplate }}</v-btn>
                                </v-col>
                                <v-col cols="6">
                                    <template v-if="feedbacks.length">
                                        <v-sheet elevation="1">
                                            <v-list-item v-for="(feedback, fIndex) in feedbacks" :key="fIndex" two-line>
                                                <v-list-item-content>
                                                    <v-list-item-title>Adaugat de {{ _.get(feedback, 'created_by.name', 'Nedefinit') }} in data de {{ new Date(feedback.created_at) | datetime }}</v-list-item-title>
                                                    <v-list-item-subtitle>{{ feedback.feedback }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-sheet>
                                    </template>
                                    <v-alert
                                        v-else
                                        dense
                                        type="info"
                                    >
                                        Nu sunt date inregistrate.
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="orange darken-1"
                            text
                            :disabled="form.busy"
                            @click="dialog = false"
                        >
                            Renuntare
                        </v-btn>
                        <v-btn
                            color="green darken-1"
                            text
                            :disabled="form.busy"
                            @click="submit"
                        >
                            Confirmare
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-col>
    </v-row>
</template>
<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    export default {
        mixins: [validationError],
        props: {
            customerId: {
                type: [String, Number],
                required: true
            },
            subjectType: {
                type: String,
                required: true
            },
            subjectId: {
                type: [String, Number],
                required: true
            },
            classes: {
                type: [Array, String],
                default() {
                    return ''
                }
            },
            disabled: {
                type: Boolean,
                default () {
                    return true
                }
            }
        },
        data () {
            return {
                dialog: false,
                feedbacks: [],
                form: new Form({
                    subject_type: this.subjectType,
                    subject_id: this.subjectId,
                    feedback: null
                })
            }
        },
        watch: {
            dialog: {
                handler(val) {
                    if(val && this.feedbacks.length < 1) {
                        this.loadFeedbacks()
                    }
                    if(!val) {
                        this.resetForm()
                    }
                }
            }
        },
        methods: {
            resetForm() {
                this.form = new Form({
                    subject_type: this.subjectType,
                    subject_id: this.subjectId,
                    feedback: null
                })
            },
            async loadFeedbacks() {
                await (new this.$db.Customer({id: this.customerId}))
                    .feedbacks()
                    .include('createdBy')
                    .orderBy('-created_at')
                    .get()
                    .then(({data}) => {
                        this.feedbacks = data
                    })
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                new this.$db.Customer({id: this.customerId}).feedbacks().attach(self.form)
                    .then(response => {
                        self.$validator.reset();
                        self.showSuccess();
                        self.resetForm()
                        this.loadFeedbacks()
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                    self.form.busy = false;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .v-list-item__subtitle, .v-list-item__title {
        white-space: normal !important;
    }
</style>
